import { initialState } from '@/Helpers.js';
import store from '@/store/Index.js';

export default function FeatureMiddleware(featureName) {
    return function createFeatureMiddleware(to, from, next) {
        const { user } = store.state.Auth;
        const featureClassName = initialState('Features')[featureName];

        const hasFeature = user?.features?.includes(featureClassName);

        if (!hasFeature) {
            next({ name: '403' });
        } else {
            next();
        }
    };
}
